module.exports = __webpack_public_path__ + "img/img28.2ab62949.png";